import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "data-item__section product__section" };
const _hoisted_2 = { class: "product__images" };
const _hoisted_3 = { class: "product__attributes" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = { class: "column" };
const _hoisted_6 = { class: "column" };
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "data-item__section product__section" };
const _hoisted_9 = {
    key: 0,
    class: "data-item__section product__section product__section--assets"
};
const _hoisted_10 = { class: "product__attributes" };
const _hoisted_11 = { class: "data-item__section product__section product__section--associations" };
import { computed, ref } from 'vue';
import ProductAttributeGroup from "@astina/paloma-shop-common-ui/src/components/ProductAttributeGroup.vue";
import ProductAttributes from "@astina/paloma-shop-common-ui/src/components/ProductAttributes.vue";
import ProductAssets from "@astina/paloma-shop-common-ui/src/components/ProductAssets.vue";
import ProductImages from "../components/ProductImages.vue";
import ProductAssociations from "../components/ProductAssociations.vue";
import ProductPackagingUnits from "@astina/paloma-shop-common-ui/src/components/ProductPackagingUnits.vue";
import ProductPastOrders from "../components/ProductPastOrders.vue";
import config from "../services/PortalConfig";
import ProductVariantDeliveryDays from "../components/ProductVariantDeliveryDays.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductDetailsView',
    props: {
        product: {}
    },
    setup(__props) {
        const displayProductUnits = ref(config.displayProductUnits);
        const displayContainedUnits = ref(config.displayContainedUnits);
        const displayProductUnitMsrp = ref(config.displayProductUnitMsrp);
        const showPriceUnavailableAltText = ref(config.showPriceUnavailableAltText);
        const showPastOrders = ref(config.productShowPastOrders);
        const props = __props;
        const productDescription = computed(() => {
            const property = config.productDetails.descriptionProperty;
            return props[property || 'description'] || null;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(ProductImages, {
                            images: __props.product.master.images
                        }, null, 8, ["images"])
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(ProductAttributeGroup, {
                                    group: "general",
                                    product: __props.product,
                                    "hide-title": true,
                                    "no-prop-borders": true
                                }, null, 8, ["product"]),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _createVNode(ProductAttributeGroup, {
                                    group: "codes",
                                    product: __props.product,
                                    "hide-title": true,
                                    "no-prop-borders": true
                                }, null, 8, ["product"])
                            ]),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                (showPastOrders.value)
                                    ? (_openBlock(), _createBlock(ProductPastOrders, {
                                        key: 0,
                                        product: __props.product
                                    }, null, 8, ["product"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (__props.product.variants.length === 1)
                            ? (_openBlock(), _createBlock(ProductPackagingUnits, {
                                key: 0,
                                variant: __props.product.variants[0],
                                displayProductUnits: displayProductUnits.value,
                                "display-contained-units": displayContainedUnits.value,
                                "display-msrp": displayProductUnitMsrp.value,
                                showPriceUnavailableAltText: showPriceUnavailableAltText.value
                            }, null, 8, ["variant", "displayProductUnits", "display-contained-units", "display-msrp", "showPriceUnavailableAltText"]))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.product.variants.length === 1 && _unref(config).productDetails.displayDeliveryDays)
                            ? (_openBlock(), _createBlock(ProductVariantDeliveryDays, {
                                key: 1,
                                "item-number": __props.product.itemNumber,
                                variant: __props.product.variants[0]
                            }, null, 8, ["item-number", "variant"]))
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (productDescription.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                innerHTML: productDescription.value,
                                class: "product__description"
                            }, null, 8, _hoisted_7))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("section", _hoisted_8, [
                    _createVNode(ProductAttributes, {
                        product: __props.product,
                        "exclude-groups": ['default', 'general', 'codes']
                    }, null, 8, ["product"])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (__props.product.master.assets.length > 0)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(ProductAssets, {
                                style: { "padding-top": "0", "margin-top": "0" },
                                assets: __props.product.master.assets
                            }, null, 8, ["assets"])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("section", _hoisted_11, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['recommended', 'similar', 'successor', 'predecessor'], (assoc) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (__props.product.associations[assoc] && __props.product.associations[assoc].length > 0)
                                ? (_openBlock(), _createBlock(ProductAssociations, {
                                    association: assoc,
                                    "item-numbers": __props.product.associations[assoc],
                                    key: assoc
                                }, null, 8, ["association", "item-numbers"]))
                                : _createCommentVNode("", true)
                        ], 64));
                    }), 64))
                ])
            ]));
        };
    }
});
